import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

// <audio> and <img> cannot send an Authorization header, so the stream and logo
// proxies take a short-lived signed token in the query string instead. Without it
// they would be an open proxy on anyone who knows the Worker URL.
const MEDIA_KEY = "radioverse_media_token";
let mediaToken = localStorage.getItem(MEDIA_KEY) || "";

const stillValid = (t) => {
  const exp = parseInt((t || "").split(".")[0], 10);
  // Renew five minutes early so a stream never starts on a token about to expire.
  return Number.isFinite(exp) && exp > Date.now() / 1000 + 300;
};

export async function ensureMediaToken() {
  if (stillValid(mediaToken)) return mediaToken;
  try {
    const { data } = await api.get("/media-token");
    mediaToken = data.token || "";
    localStorage.setItem(MEDIA_KEY, mediaToken);
  } catch {
    mediaToken = "";
    localStorage.removeItem(MEDIA_KEY);
  }
  return mediaToken;
}
export function clearMediaToken() {
  mediaToken = "";
  localStorage.removeItem(MEDIA_KEY);
}

export const streamUrl = (url) => `${API}/stream?url=${encodeURIComponent(url)}&t=${encodeURIComponent(mediaToken)}`;
export const logoUrl = (url) => (url ? `${API}/logo?url=${encodeURIComponent(url)}&t=${encodeURIComponent(mediaToken)}` : "");

// Attach the right token per request. Admin endpoints use the admin token; user
// endpoints prefer the user token but fall back to the admin token so an admin can
// browse the user-facing app in preview mode.
api.interceptors.request.use((config) => {
  const isAdminUrl = (config.url || "").startsWith("/admin");
  const userToken = localStorage.getItem("radioverse_token");
  const adminToken = localStorage.getItem("radioverse_admin_token");
  const token = isAdminUrl ? adminToken : userToken || adminToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function errMsg(e) {
  return formatApiError(e?.response?.data?.detail) || e?.message || "Network error";
}
